import { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import { PaymentMethodsPayload } from '../../../../../../../utils/reducers/payments/paymentMethods'
import { PaymentTypesPayload } from '../../../../../../../utils/reducers/payments/paymentTypes'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import ModalFiltersMarkRemittanceAsPaid from './ModalFiltersMarkRemittanceAsPaid'
import ModalSelectRemittanceAsPaid from './ModalSelectRemittanceAsPaid'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'


type ModalMarkRemittanceAsPaidProps = ReduxModalMarkRemittanceAsPaid & ModalEditComponentProps & {}

const ModalMarkRemittanceAsPaid: React.FC<ModalMarkRemittanceAsPaidProps> = ({ paymentTypes, paymentMethods, workingCenters, setOpened, onSubmit}) => {
    const { preSearchFilters, setPreSearchFilters } = useModalMarkRemittanceAsPaidLogic()
    if (preSearchFilters === null){
        return <ModalFiltersMarkRemittanceAsPaid {...{ paymentTypes, paymentMethods, setOpened, preSearchFilters, setPreSearchFilters}}/>
    }
    return (
        <ModalSelectRemittanceAsPaid {...{ preSearchFilters,  setOpened, onSubmit, setPreSearchFilters, workingCenters, paymentTypes, paymentMethods }} />
    )
}

const useModalMarkRemittanceAsPaidLogic = () => {
    const [preSearchFilters, setPreSearchFilters] = useState<TwinDictionary | null>(null)
    return { preSearchFilters, setPreSearchFilters }
}

const modalMarkRemittanceAsPaidDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
    setPaymentMethods: (payload: PaymentMethodsPayload) => ({ type: 'CHANGE_PAYMENTMETHODS', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

type ReduxModalMarkRemittanceAsPaid = ConnectedProps<typeof modalMarkRemittanceAsPaidConnect>
const mapModalMarkRemittanceAsPaidConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes, paymentMethods: state.paymentMethods, workingCenters: state.workingCenters })
const modalMarkRemittanceAsPaidConnect = connect(mapModalMarkRemittanceAsPaidConnector, modalMarkRemittanceAsPaidDispatch)
const modalMarkRemittanceAsPaidConnectLoading = withLoading(ModalMarkRemittanceAsPaid, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }, { fetchUrl: '/api/app/config/payment/paymentMethod/getAllPaymentMethods', propName: 'paymentMethods', setFunctionName: 'setPaymentMethods' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalMarkRemittanceAsPaidConnect = modalMarkRemittanceAsPaidConnect(modalMarkRemittanceAsPaidConnectLoading)


export default ModalMarkRemittanceAsPaidConnect